import toastr from "toastr";

toastr.options = {
  closeButton: true,
  closeHtml: `<span class="toast-close">&times;</span>`,
};
export default toastr;
